import { Box, Center, Flex, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import Link from "next/link";
import React from "react";

const details = [
  {
    imgUrl: "/assets/institutions/audits/multi-sign.svg",
    text: "MULTI-SIGN",
    subText: "6/8 signers required for upgrades",
  },
  {
    imgUrl: "/assets/institutions/audits/time-lock.svg",
    text: "TIME-LOCK",
    subText: "10 day time-lock enforced for all upgrades",
  },
];

const Audits = () => {
  return (
    <Center
      flexDir={"column"}
      maxWidth="1512px"
      w="100%"
      px={{ base: 5, md: 20 }}
      py={20}
    >
      <Center maxW={593} flexDir={"column"}>
        <Text fontSize={40} fontWeight={500} textAlign="center">
          Audited & approved
        </Text>
        <Text fontSize={20} fontWeight={500} mt={3} textAlign="center">
          Kelp&apos;s rsETH has undergone multiple audits to thoroughly evaluate
          the protocol&apos;s security and functionality.
        </Text>
      </Center>
      <Flex maxW={584} my={16} gap={6} flexDir={{ base: "column", md: "row" }}>
        {details.map((detail) => (
          <Center
            w={280}
            flexDir={"column"}
            gap={3}
            key={detail.text}
            textAlign="center"
          >
            <BaseImage
              height={32}
              width={32}
              src={detail.imgUrl}
              alt={detail.text}
            />
            <Text fontSize={18} fontWeight={500}>
              {detail.text}
            </Text>
            <Text fontSize={20} fontWeight={500} color={"#142528"}>
              {detail.subText}
            </Text>
          </Center>
        ))}
      </Flex>
      <Flex maxW={436} gap={3} flexDir={{ base: "column", md: "row" }}>
        <Box
          w={{ base: "100%", md: 221 }}
          gap={3}
          bg="#313131"
          borderRadius="9px"
          p={3}
        >
          <BaseImage
            height={36}
            width={36}
            src={"/assets/institutions/audits/sigma-prime.svg"}
            alt={"sigma"}
          />
          <Text
            mt={6}
            mb={2}
            fontSize={24}
            lineHeight={7}
            fontWeight={500}
            color="white"
          >
            Audited by SigmaPrime
          </Text>
          <Link
            href="https://kelpdao.xyz/audits/smartcontracts/SigmaPrime.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <Text
              fontSize={12}
              mb={3}
              fontWeight={500}
              lineHeight={"100%"}
              color={"#696969"}
            >
              VIEW REPORT
            </Text>
          </Link>
        </Box>
        <Flex flexDir={"column"} justify={"space-between"} gap={3} h={176}>
          <Flex
            w={{ base: "100%", md: 203 }}
            h={82}
            bg="#261A4E"
            borderRadius="9px"
            alignItems={{ base: "center", md: "flex-start" }}
            p={3}
            gap={3}
          >
            <BaseImage
              height={36}
              width={36}
              src={"/assets/institutions/audits/code4rena.svg"}
              alt={"sigma"}
            />
            <Box>
              <Text mb={2} fontWeight={500} lineHeight={"100%"} color="white">
                Audited by code4rena
              </Text>
              <Link
                href="https://code4rena.com/reports/2023-11-kelp"
                target="_blank"
                rel="noreferrer"
              >
                <Text
                  fontSize={12}
                  fontWeight={500}
                  lineHeight={"100%"}
                  color={"#696969"}
                >
                  VIEW REPORT
                </Text>
              </Link>
            </Box>
          </Flex>
          <Flex
            w={{ base: "100%", md: 203 }}
            h={82}
            bg="#55AD7D"
            alignItems={{ base: "center", md: "flex-start" }}
            borderRadius="9px"
            p={3}
            gap={3}
          >
            <BaseImage
              height={36}
              width={36}
              src={"/assets/institutions/audits/mix-bytes.svg"}
              alt={"sigma"}
            />
            <Box>
              <Text mb={2} fontWeight={500} lineHeight={"100%"} color="white">
                Audited by Mixbytes
              </Text>
              <Link
                href="https://kelpdao.xyz/audits/smartcontracts/mixbytes.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <Text
                  fontSize={12}
                  fontWeight={500}
                  lineHeight={"100%"}
                  color={"#696969"}
                >
                  VIEW REPORT
                </Text>
              </Link>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Center>
  );
};

export default Audits;
